module.exports = __webpack_public_path__ + "static/media/feature_img_3.0f57ee69.png";